import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment } from "react";
import { useTheme } from "../../styles";
import { Icon } from "../Icon";
import { Label } from "../Text";
import { View } from "../View";
/**
 * Displays potential outcomes for a given practice and whether or not they were
 * achieved.
 *
 * {@adf 💾̀̀̇̋̀̀̂̂̀̀̇̄̀̀̇̉̀̀̇̀̀̀̆̅̀̀̂̂̀̀̃̊̀̀̂̂̀̀̆̍̀̀̆̅̀̀̆̄̀̀̆̉̀̀̆́̀̀̅̃̀̀̆̉̀̀̆̎̀̀̆̇̀̀̆̌̀̀̆̅̀̀̂̂̀̀̂̌̀̀̂̂̀̀̆́̀̀̇̄̀̀̇̄̀̀̇̂̀̀̇̃̀̀̂̂̀̀̃̊̀̀̇̋̀̀̂̂̀̀̆̌̀̀̆́̀̀̇̉̀̀̆̏̀̀̇̅̀̀̇̄̀̀̂̂̀̀̃̊̀̀̂̂̀̀̆́̀̀̆̌̀̀̆̉̀̀̆̇̀̀̆̎̀̀̂̍̀̀̇̃̀̀̇̄̀̀̆́̀̀̇̂̀̀̇̄̀̀̂̂̀̀̇̍̀̀̂̌̀̀̂̂̀̀̆̃̀̀̆̏̀̀̆̎̀̀̇̄̀̀̆̅̀̀̆̎̀̀̇̄̀̀̂̂̀̀̃̊̀̀̅̋̀̀̇̋̀̀̂̂̀̀̇̄̀̀̇̉̀̀̇̀̀̀̆̅̀̀̂̂̀̀̃̊̀̀̂̂̀̀̆̍̀̀̆̅̀̀̆̄̀̀̆̉̀̀̆́̀̀̂̂̀̀̂̌̀̀̂̂̀̀̆́̀̀̇̄̀̀̇̄̀̀̇̂̀̀̇̃̀̀̂̂̀̀̃̊̀̀̇̋̀̀̂̂̀̀̇̄̀̀̇̉̀̀̇̀̀̀̆̅̀̀̂̂̀̀̃̊̀̀̂̂̀̀̆̆̀̀̆̉̀̀̆̌̀̀̆̅̀̀̂̂̀̀̂̌̀̀̂̂̀̀̆̉̀̀̆̄̀̀̂̂̀̀̃̊̀̀̂̂̀̀̆̃̀̀̆̆̀̀̆̆̀̀̆̆̀̀̃̆̀̀̃̆̀̀̆̆̀̀̃̆̀̀̂̍̀̀̃̂̀̀̃̂̀̀̆̆̀̀̃̆̀̀̂̍̀̀̃̄̀̀̃̈̀̀̃̈̀̀̃̉̀̀̂̍̀̀̆́̀̀̆̆̀̀̆̆̀̀̃̈̀̀̂̍̀̀̃̇̀̀̃̈̀̀̃̉̀̀̃̆̀̀̃̅̀̀̃̂̀̀̃̂̀̀̃́̀̀̆̄̀̀̃̆̀̀̃̃̀̀̆̃̀̀̂̂̀̀̂̌̀̀̂̂̀̀̆́̀̀̆̌̀̀̇̄̀̀̂̂̀̀̃̊̀̀̂̂̀̀̆̉̀̀̆̍̀̀̆́̀̀̆̇̀̀̆̅̀̀̂̍̀̀̃̂̀̀̃̀̀̀̃̂̀̀̃̅̀̀̃̀̀̀̃́̀̀̃̀̀̀̃̆̀̀̂̍̀̀̃̂̀̀̃̂̀̀̃̃̀̀̃̉̀̀̃̀̀̀̃̀̀̀̂̎̀̀̇̀̀̀̆̎̀̀̆̇̀̀̂̂̀̀̂̌̀̀̂̂̀̀̆̃̀̀̆̏̀̀̆̌̀̀̆̌̀̀̆̅̀̀̆̃̀̀̇̄̀̀̆̉̀̀̆̏̀̀̆̎̀̀̂̂̀̀̃̊̀̀̂̂̀̀̂̂̀̀̂̌̀̀̂̂̀̀̆̈̀̀̆̅̀̀̆̉̀̀̆̇̀̀̆̈̀̀̇̄̀̀̂̂̀̀̃̊̀̀̃̃̀̀̃́̀̀̃̉̀̀̂̌̀̀̂̂̀̀̇̇̀̀̆̉̀̀̆̄̀̀̇̄̀̀̆̈̀̀̂̂̀̀̃̊̀̀̃̆̀̀̃̀̀̀̃̉̀̀̇̍̀̀̇̍̀̀̅̍̀̀̇̍}
 *
 * @see {@link https://ouihealth.atlassian.net/browse/APPCORE-31}
 */ export var PracticeOutcome = function(param) {
    var outcomes = param.outcomes;
    var theme = useTheme().theme;
    return /*#__PURE__*/ _jsx(View, {
        style: {
            backgroundColor: 'white',
            borderRadius: 10,
            paddingVertical: 5,
            borderWidth: 1,
            borderBottomWidth: 2,
            borderColor: theme.color.dark
        },
        children: outcomes.map(function(outcome, i, arr) {
            return /*#__PURE__*/ _jsxs(Fragment, {
                children: [
                    /*#__PURE__*/ _jsxs(View, {
                        style: {
                            paddingHorizontal: 10,
                            paddingVertical: 15,
                            justifyContent: 'space-between'
                        },
                        row: true,
                        children: [
                            /*#__PURE__*/ _jsxs(View, {
                                row: true,
                                style: {
                                    gap: 10
                                },
                                children: [
                                    /*#__PURE__*/ _jsx(Icon, {
                                        name: outcome.icon,
                                        size: 16,
                                        color: theme.color.gray400
                                    }),
                                    /*#__PURE__*/ _jsx(Label, {
                                        text: outcome.text
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsx(View, {
                                style: [
                                    {
                                        borderWidth: 1,
                                        borderRadius: 20,
                                        width: 25,
                                        height: 25,
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        borderColor: theme.color.gray500
                                    },
                                    outcome.value ? {
                                        borderColor: theme.color.accent100,
                                        backgroundColor: theme.color.accent100
                                    } : null
                                ],
                                children: /*#__PURE__*/ _jsx(Icon, {
                                    name: "check",
                                    color: "white",
                                    size: 12
                                })
                            })
                        ]
                    }),
                    i < arr.length - 1 ? /*#__PURE__*/ _jsx(View, {
                        style: {
                            width: '100%',
                            height: 1,
                            backgroundColor: theme.color.gray700
                        }
                    }) : null
                ]
            }, outcome.text);
        })
    });
};
